import { render, staticRenderFns } from "./goods-batch-picker.component.vue?vue&type=template&id=185824f3"
import script from "./goods-batch-picker.component.vue?vue&type=script&lang=js"
export * from "./goods-batch-picker.component.vue?vue&type=script&lang=js"
import style0 from "./goods-batch-picker.component.vue?vue&type=style&index=0&id=185824f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports